"use client";

import { Stack, Tabs, Title } from "@mantine/core";
import { useQueryState } from "nuqs";

import { FlowContentContainer } from "@/components/layout/flow-content-container";
import { FlowPaper } from "@/components/layout/flow-paper";
import { FlowTabs } from "@/components/layout/flow-tabs";
import { FlowTabsPanel } from "@/components/layout/flow-tabs-panel";

import { CompletedCoursesList } from "./completed-courses-list";
import { UserFeedbackList } from "./user-feedback";

export function RecentActivities() {
  const [activity, setActivity] = useQueryState("activity", {
    defaultValue: "completed",
  });

  return (
    <Stack
      bg="white"
      className="border rounded-lg border-primary-border-light backdrop-blur-sm w-full"
      p={20}
      gap={16}
    >
      <Title className="prose-xl/medium text-primary-text-body">
        Recent activities
      </Title>

      <FlowTabs value={activity} onChange={setActivity} px={20}>
        <Tabs.List>
          <Tabs.Tab value="completed">Courses Completed</Tabs.Tab>
          <Tabs.Tab value="feedback">User Feedback</Tabs.Tab>
        </Tabs.List>

        <FlowTabsPanel value="completed" mih={300}>
          <FlowContentContainer h="100%">
            <FlowPaper>
              <CompletedCoursesList />
            </FlowPaper>
          </FlowContentContainer>
        </FlowTabsPanel>

        <FlowTabsPanel value="feedback" mih={300}>
          <FlowContentContainer h="100%">
            <FlowPaper>
              <UserFeedbackList />
            </FlowPaper>
          </FlowContentContainer>
        </FlowTabsPanel>
      </FlowTabs>
    </Stack>
  );
}
